<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <div class="d-flex align-items-center gap-2">
          <ng-container *ngIf="tab === 'automations'">
            <h6 class="modal-title" i18n>Document Automations</h6>
            <app-page-help articleId="nM6G7JwGKE9eiyt8ThH5U3" videoId="-"></app-page-help>
          </ng-container>
          <ng-container *ngIf="tab === 'templates'">
            <h6 class="modal-title" i18n>Document Templates</h6>
            <app-page-help articleId="2akBWmFNv5hnjSyNetXSCb" videoId="-"></app-page-help>
          </ng-container>
        </div>
        <div class="flex-fill"></div>
        <button (click)="onAddAutomation()" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info">
          <span class="far fa-plus"></span>
          <ng-container i18n>Automation</ng-container>
        </button>
        <button
          type="button"
          class="btn btn-secondary-info"
          [disabled]="1 | isReadonlyRole"
          (click)="templates?.onAdd()"
        >
          <span class="far fa-plus"></span> <ng-container i18n>Template</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar bg-white border-bottom">
      <li [class.active]="tab === 'automations'">
        <a (click)="tab = 'automations'" i18n>Automations</a>
      </li>
      <li [class.active]="tab === 'templates'">
        <a (click)="tab = 'templates'" i18n>Templates</a>
      </li>
    </ul>
    <div class="modal-body">
      <div class="container-box">
        <app-document-automations
          [class.d-none]="tab !== 'automations'"
          [showActions]="true"
        ></app-document-automations>
        <app-document-templates [class.d-none]="tab !== 'templates'" #templates></app-document-templates>
      </div>
    </div>
  </div>
</div>
